import { BaseRouteState, Policy, SocialReferent, ClientPreferences, TrustedThirds } from '@shared/data-access'
import { flow, types, getRoot } from 'mobx-state-tree'
import { actions, getTrustedThirdData } from '@sr/routes/common'
import { t } from 'i18next'

export const TrustedPersonBlockState = BaseRouteState.named(
  'TrustedPersonBlockState',
)
  .props({
    policyId: types.maybeNull(types.string),
    policy: types.maybeNull(types.reference(Policy)),
    user: types.maybeNull(types.reference(SocialReferent)),
    clientPreferences: types.maybeNull(types.reference(ClientPreferences)),
    clientPreferencesId: types.maybeNull(types.string),
    trustedThird: types.maybeNull(types.reference(TrustedThirds)),
    trustedThirdId: types.maybeNull(types.string),
    isEditing: false,
  })
  .views((self) => ({
    get trustedPersonData() {
      if (!self.trustedThird) return [] 
      return getTrustedThirdData({
        t,
        isEditing: self.isEditing,
        ...self.trustedThird,
      }).filter((val) => val)
    },
  }))
  .actions((self) => ({
    afterAttach() {
      self.loadDependencies()
    },
    loadDependencies: flow(function* loadDependencies() {
      self.setLoading('TrustedPersonBlockState')
      try {
        yield self.loadPolicy()
        yield self.getTrustedThird()
      } finally {
        self.removeLoading('TrustedPersonBlockState')
      }
    }),
    getTrustedThird: flow(function* getTrustedThird() {
      if (!self.policy) return
      self.setLoading('getTrustedThird')
      try {
        const trustedThirdId = self.policy?._relationships?.trustedThird?.data?.id || null
        
        if (!trustedThirdId) return
        
        const trustedThirdData = yield getRoot(self).TrustedThirdsStore.fetch(
          null,
          {
            withoutId: true,
            customUrl: `/trusted_thirds/${trustedThirdId}`,
          })

        if (trustedThirdData) {
          self.trustedThird = trustedThirdData
          self.trustedThirdId = trustedThirdData.id
        }
      } catch (error) {
        console.error('Error Fetching Trusted Third sent data:', error)
      } finally {
        self.removeLoading('getTrustedThird')}
    }),
    setEditingMode(mode) {
      self.isEditing = mode
    },
    reload() {
      self.loadDependencies()
    },
    ...actions(self),
  }))
